import { compactAddress } from "@/lib/function";
import Image from "next/image";
import React from "react";
import { useAccount, useWalletClient } from "wagmi";
import { BaseButton } from "../share/button";
import { UserAdmin } from "@/types";
import { accountSelector } from "@/store/account/account.slice";
import { useSelector } from "react-redux";
import { useIsMobile } from "@/hooks/use-mobile";
interface Props {
  onCancel: () => void;
}

function ChangeWalletModal(props: Props) {
  const { onCancel } = props;
  const { address, connector } = useAccount({});
  const { data: walletClient } = useWalletClient();
  const { account } = useSelector(accountSelector);
  const { isMobile } = useIsMobile(768);

  return (
    <div className="text-center">
      <div>
        <div className="flex items-center justify-center border border-gray-100 rounded-md p-3 md:p-5">
          <div className="relative flex flex-col items-center justify-between py-2.5 px-4 md:py-5 md:px-8 bg-[#f9fafb] mx-3">
            <Image
              width={isMobile ? 30 : 60}
              height={isMobile ? 30 : 60}
              src={`/icons/wallets/${connector?.id}.svg`}
              alt=""
            />
            <h6 className="text-xs md:text-sm font-bold ">
              {compactAddress(address)}
            </h6>
            <div className="absolute top-[-8px] right-[-8px]">
              <Image
                width={isMobile ? 16 : 24}
                height={isMobile ? 16 : 24}
                alt=""
                src="/icons/wallets/close_red.svg"
              />
            </div>
          </div>
          <Image
            width={isMobile ? 15 : 20}
            height={isMobile ? 15 : 20}
            src={`/double_arrow.png`}
            alt=""
          />
          <div className="relative flex flex-col items-center justify-between py-2.5 px-4 md:py-5 md:px-8 bg-[#f9fafb] mx-3">
            <Image
              width={isMobile ? 30 : 60}
              height={isMobile ? 30 : 60}
              src={`/icons/wallets/${connector?.id}.svg`}
              alt=""
            />
            <h6 className="text-xs md:text-sm font-bold ">
              {compactAddress(account?.walletAddress)}
            </h6>
            <div className="absolute top-[-8px] right-[-8px]">
              <Image
                width={isMobile ? 16 : 24}
                height={isMobile ? 16 : 24}
                alt=""
                src="/icons/wallets/tick_green.svg"
              />
            </div>
          </div>
        </div>
      </div>

      <BaseButton
        onClick={() => {
          walletClient.requestPermissions({ eth_accounts: {} });
        }}
        className="w-full px-6 py-3 rounded-md h-10 md:h-12 text-base font-bold text-white mt-4"
      >
        Chuyển đổi địa chỉ ví
      </BaseButton>
    </div>
  );
}

export default ChangeWalletModal;
